import Axios from "axios";
import constants from "../constants/constants.json";
import { setPlanMeAction, setPlansAction } from "../store/actions/user";
import Message from "../helper/Message";

export const plansAPI = async (dispatch) => {
  let response = await Axios.get(constants.url + "/plan/list", {
    headers: {
      authorization: "Bearer  " + localStorage.getItem("pnsToken"),
    },
  });

  if (response.data.status === 202) {
    dispatch(setPlansAction(response.data.result.plans));
  } else {
    Message.error(response.data.result.message);
  }
};

export const planMeAPI = async (dispatch) => {
  let responsePlan = await Axios.get(constants.url + "/plan/me", {
    headers: {
      authorization: "Bearer " + localStorage.getItem("pnsToken"),
    },
  });
  if (responsePlan.data.status === 202) {
    dispatch(setPlanMeAction(responsePlan.data.result));
  } else {
    Message.error(responsePlan.data.result.message);
  }
};
